export const iconFontAwesomeConstructionTrowel = (
	<i className="fa-solid fa-trowel"></i>
);
